import { createFileRoute } from '@tanstack/react-router';

import RegistrationStage from '@/ui/pages/Installer/stages/registration/RegistrationStage';

// HS-1636: stage 1 — scan the kiosk's registration QR (or type the serial) and register the device.
export const Route = createFileRoute('/_dashboard/installer/installations/$id/registration')({
  component: RegistrationStage,
});
